<template>
  <div class="ad_button" @click.stop="$emit('onclick')">
    {{this.text}}
  </div>
</template>

<script>
export default {
  name: 'Button',
  props: ['text'],
  methods: {
    
  }
};
</script>

<style>
  .ad_button{
    background: #FC5322;
    box-shadow: 0px 6px 8px 0px rgba(252, 83, 34, 0.1);
    border-radius: 2px;
    padding: 14px 20px;
    font-size: 16px;
    font-family: Helvetica;
    color: #FFFFFF;
    line-height: 20px;
    cursor: pointer;
    display: inline-block;
  }
  .ad_button:hover, .ad_button:focus{
    background: #E34A1E;
    box-shadow: 0px 6px 8px 0px rgba(252, 83, 34, 0.1);
  }
  .ad_button:active{
    background: #E34A1E;
    box-shadow: 0px 6px 8px 0px rgba(252, 83, 34, 0.1);
  }

  @media (max-width: 767px){
    .ad_button{
      padding: .32rem .2rem;
      border-radius: 6px;
      font-weight: bold;
      font-size: .27rem;
      color: #FFFFFF;
      line-height: .29rem;
      border: none;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/button/button.vue